// @ts-nocheck
/* eslint-disable */

import React from 'react';
import AddEntity from '../../components/CRUD/AddEntity';
import ValidationRulesBuilder, { buildValidationRules } from './ValidationRulesBuilder';

const AddDocumentType = () => {
  const inputs = [
    {
      name: 'code',
      labelKey: 'Code',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'en_name',
      labelKey: 'NameEnglish',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'ar_name',
      labelKey: 'NameArabic',
      type: 'text',
      required: true,
      defaultValue: ''
    }
  ];

  const buildSubmitPayload = (formValues) => {
    const payload: any = {
      code: formValues.code,
      en_name: formValues.en_name,
      ar_name: formValues.ar_name,
    };
    const rules = buildValidationRules(formValues);
    if (rules) payload.validation_rules = rules;
    return payload;
  };

  return (
    <AddEntity
      pageTitle="AddNewDocumentType"
      backUrl="/fare-products/document-types"
      submitApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/document_types`}
      inputs={inputs}
      dropdowns={[]}
      buildSubmitPayload={buildSubmitPayload}
      successMessage="DocumentTypeCreatedSuccessfully"
      subsystemName="DocumentTypes"
      permissionSystem="fares"
      renderAboveSubmit={(formValues, setFormValues) => (
        <ValidationRulesBuilder formValues={formValues} setFormValues={setFormValues} />
      )}
    />
  );
};

export default AddDocumentType;
